import { CardContent, Divider } from "@mui/material";
import { Card, Grid, Spacer, Typography } from "../style";

const StatoAssicurativo = ({ veicolo }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Stato Assicurativo
        </Typography>

        <Spacer mb={4} />

        <Grid container direction="row" alignItems="center" mb={2} gap={4}>
          <Grid item sm={4}>
            <Typography sx={{ fontWeight: "bold" }}>Compagnia</Typography>
          </Grid>
          <Grid item sm={6}>
            {veicolo?.assicurazioneProvenienza}
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2} gap={4}>
          <Grid item sm={4}>
            <Typography sx={{ fontWeight: "bold" }}>Polizza</Typography>
          </Grid>
          <Grid item sm={6}>
            {veicolo?.numeroPolizza}
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2} gap={4}>
          <Grid item sm={4}>
            <Typography sx={{ fontWeight: "bold" }}>Tariffa</Typography>
          </Grid>
          <Grid item sm={6}>
            {veicolo?.tariffa.value}
          </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2} gap={4}>
          <Grid item sm={4}>
            <Typography sx={{ fontWeight: "bold" }}>Copertura</Typography>
          </Grid>
          <Grid item sm={6}>
            {veicolo?.dataInizioCopertura &&
              veicolo?.dataFineCopertura &&
              `dal ${veicolo?.dataInizioCopertura} al ${veicolo?.dataFineCopertura}`}
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  );
};

export default StatoAssicurativo;
